import React from 'react';
import { useLocation } from 'react-router-dom';

interface CanonicalLinkProps {
  url?: string;
}

const CanonicalLink: React.FC<CanonicalLinkProps> = ({ url }) => {
  const location = useLocation();
  const baseUrl = 'https://nemlingo.com';
  const canonicalUrl = url || `${baseUrl}${location.pathname}`;

  React.useEffect(() => {
    // Check if canonical link already exists
    let link = document.querySelector('link[rel="canonical"]');
    
    // If it doesn't exist, create it
    if (!link) {
      link = document.createElement('link');
      link.setAttribute('rel', 'canonical');
      document.head.appendChild(link);
    }
    
    // Set the href attribute
    link.setAttribute('href', canonicalUrl);
    
    // Cleanup function
    return () => {
      // No cleanup needed as we're just updating the link
    };
  }, [canonicalUrl]);

  return null;
};

export default CanonicalLink;
